import React from "react";
import PropTypes from "prop-types";
import styles from "./SettingsListHeader.module.css";

export function SettingsListHeader({ header }) {
  return (
    <div className={styles.header}>
     {header}
    </div>
  );
}

SettingsListHeader.propTypes = {
  header: PropTypes.string,
};
